import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import CasinoHeading from "../../casinoComponents/casinoHeading";
import BetTableTeenPatti6 from "../../casinoComponents/betTableTeenPatti6";
import MyBet from "../../casinoComponents/myBet";
import VideoBox from "../../casinoComponents/videoBox";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import Teen6CardsOverlay from "../../casinoComponents/videoBox/overlays/Teen6CardsOverlay";
import ViewMoreModal from "../../../components/ViewMoreModal";
import ResultTeen6 from "../resultui/resultTeen6/ResultTeen6";
import { getCasinoGameDetails, getMatchExposure, getMyBets } from "../../../apiservices/CasionApi";
import PlaceBet from "../../casinoComponents/placeBet/NoBet";
import { extractCasinoGame } from "../../../utils/casinoGame";
import { formatTeen6Nation } from "../../../utils/casinoMyBets";
import "../../../styles/games/teen6.css";

// Reference game header title (casino/teenpatti2 → lastresults res1.cname)
const TITLE = "Teenpatti - 2.0";

export default function TeenPatti6() {
  const [gameData, setGameData] = useState({});
  const [betValue, setBetValue] = useState("");
  const [selectedPlayerName, setSelectedPlayerName] = useState("");
  const [selectedPlayerNameForApi, setSelectedPlayerNameForApi] = useState("Player A");
  const [selectedSelection, setSelectedSelection] = useState("");
  const [selectedBetData, setSelectedBetData] = useState(null);
  const [selectedBetType, setSelectedBetType] = useState("back");
  const [iframeSrc, setIframeSrc] = useState("");
  const { pathname } = useLocation();
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);

  const [, setShowPlaceBet] = useState(false);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);

  useEffect(() => {
    const name = extractCasinoGame(pathname);
    setIframeSrc(`https://stream-s-43.uhdmovies.online/casino-stream?id=${name}`);

    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(name);
        setGameData(response);
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    fetchGameData();
    const interval = setInterval(fetchGameData, 1500);
    return () => clearInterval(interval);
  }, [pathname]);



  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId = gameData?.data?.data?.mid?.toString();

      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          // Convert array to object keyed by team_name
          const exposureMap = {};
          response.data.forEach((item) => {
            const teamName = item.team_name;
            const exposureAmount = parseFloat(item.exposure_amount) || 0;

            // Add the team name as-is
            exposureMap[teamName] = exposureAmount;
            exposureMap[teamName?.trim()] = exposureAmount;
            exposureMap[teamName?.toLowerCase()] = exposureAmount;
            exposureMap[teamName?.toLowerCase().trim()] = exposureAmount;

            // For Player A/B, also create Back/Lay keys (we'll distribute the exposure)
            if (teamName && (teamName.includes("Player A") || teamName.includes("Player B"))) {
              // Split exposure between Back and Lay if we have both types
              // For now, assign to both keys (will be overridden by myBets if more specific)
              exposureMap[`${teamName} Back`] = exposureAmount;
              exposureMap[`${teamName} Lay`] = exposureAmount;
            }
          });
          setExposures(exposureMap); // replace, not merge: a settled / finished round's book must drop
        }
      }
    } catch (error) {
      console.error('Error fetching exposure:', error);
    }
  }, [gameData?.data?.data?.mid]);

  const handleBetClick = (value, selection, betType, betData = null, tablePlayerName = null) => {
    if (!value) return;
    setBetValue(value);
    setSelectedPlayerName(selection || "");
    setSelectedSelection(selection || "");
    setSelectedBetType(betType || "back");
    setSelectedBetData(betData || { nat: selection, subtype: betData?.subtype || "", gtype: "teen6" });
    // Set player_name based on which table was clicked (A or B) or default to Player A
    if (tablePlayerName) {
      setSelectedPlayerNameForApi(`Player ${tablePlayerName}`);
    } else if (betData?.nat?.includes("Player A")) {
      setSelectedPlayerNameForApi("Player A");
    } else if (betData?.nat?.includes("Player B")) {
      setSelectedPlayerNameForApi("Player B");
    } else {
      setSelectedPlayerNameForApi("Player A");
    }
    setShowPlaceBet(true);
  };

  const handleBetPlaced = () => {
    // Clear all bet-related state to hide PlaceBet UI
    setShowPlaceBet(false);
    setBetValue("");
    setSelectedPlayerName("");
    setSelectedSelection("");
    setSelectedBetData(null);
    setSelectedBetType("back");
    setSelectedPlayerNameForApi("Player A");
    // Fetch exposure and my bets after bet placement
    fetchExposure();
    fetchMyBetsData();
  };

  const fetchMyBetsData = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId = gameData?.data?.data?.mid?.toString();

      if (userId && matchId) {
        const response = await getMyBets(userId, matchId);
        if (response.success && response.bets) {
          // Map bets data to format needed for MyBet component
          const formattedBets = response.bets.map((bet) => ({
            // My Bets "Gametype" column (casino_bets.game_name, e.g. mogambo)
            description: bet.description ?? bet.game_name ?? bet.gameName,
            userName: bet.userName ?? bet.username,
            placeDate: bet.placeDate ?? bet.created_at,
            matchedBet: bet.player_name || bet.selection || "",
            odds: bet.odds || "0",
            stake: bet.stake || "0",
            type: bet.type || null, // Include type field for background color
            selection: bet.selection || bet.player_name || "",
            exposer: parseFloat(bet.exposer || bet.exposure_amount || "0") || 0
          }));
          setMyBets(formattedBets);

          // Map exposure from myBets to exposures object (like in lucky7)
          const exposureMap = {};
          response.bets.forEach((bet) => {
            const selection = bet.selection || bet.player_name || "";
            const betType = bet.type || "back"; // "back" or "lay"
            const exposureAmount = parseFloat(bet.exposer || bet.exposure_amount || "0") || 0;

            if (selection && exposureAmount !== 0) {
              // Add the selection as-is (e.g., "Player A", "Heart")
              exposureMap[selection] = exposureAmount;
              exposureMap[selection.trim()] = exposureAmount;
              exposureMap[selection.toLowerCase().trim()] = exposureAmount;
              exposureMap[selection.toLowerCase()] = exposureAmount;

              // For Player A/B bets, also create keys with Back/Lay suffix
              if (selection.includes("Player A") || selection.includes("Player B")) {
                const backKey = `${selection} Back`;
                const layKey = `${selection} Lay`;
                if (betType === "back") {
                  exposureMap[backKey] = exposureAmount;
                  exposureMap[backKey.toLowerCase()] = exposureAmount;
                } else if (betType === "lay") {
                  exposureMap[layKey] = exposureAmount;
                  exposureMap[layKey.toLowerCase()] = exposureAmount;
                }
              }
            }
          });
          // Merge with existing exposures from getMatchExposure
          setExposures(prev => ({ ...prev, ...exposureMap }));
        }
      }
    } catch (error) {
      console.error('Error fetching my bets:', error);
    }
  }, [gameData?.data?.data?.mid]);

  // Fetch exposure on mount and periodically with debounce
  useEffect(() => {
    const matchId = gameData?.data?.data?.mid?.toString();
    if (!matchId) return;

    // Initial fetch after 2 seconds
    const timeoutId = setTimeout(() => {
      fetchExposure();
      fetchMyBetsData();
    }, 2000);

    // Periodic fetch every 2 seconds
    const intervalId = setInterval(() => {
      fetchExposure();
      fetchMyBetsData();
    }, 2000);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, [gameData?.data?.data?.mid, fetchExposure, fetchMyBetsData]);

  const d = gameData?.data?.data;
  const subData = d?.sub || [];

  // Bet table click (value, selection, type, betData) → same bet state as before
  const handleTableBetClick = (value, selection, type, betData) => {
    const nat = betData?.nat || selection || "";
    let tablePlayerName = null;
    if (betData?.subtype === "teen6" || betData?.subtype === "uo") {
      if (nat.includes("Player A")) tablePlayerName = "A";
      else if (nat.includes("Player B")) tablePlayerName = "B";
    }
    handleBetClick(value, selection, type, betData || { nat: selection, subtype: "teen6", gtype: "teen6" }, tablePlayerName);
  };

  return (
    <CasinoTableLayout
      tableClass="teenpatti2"
      rightSide={<MyBet bets={myBets} formatNation={formatTeen6Nation} onViewMore={() => setShowViewMoreModal(true)} />}
    >
      <>
        <CasinoHeading name={TITLE} roundId={d?.mid || ""} />
        <VideoBox
          gameType="teen6"
          resultData={d?.card}
          iframeSrc={iframeSrc}
          timerValue={d?.lt}
          cardsOverlay={<Teen6CardsOverlay card={d?.card} />}
        />
        {d?.mid ? (
          <div className="casino-detail">
            <BetTableTeenPatti6 data={subData} onBetClick={handleTableBetClick} exposures={exposures} />{" "}
            <CasinoLastResult gameType="teen6" resultComponent={<ResultTeen6 gameType="teen6" fallbackTitle={TITLE} />} />
          </div>
        ) : null}
        {/* Admin panel does not place bets: NoBet stub renders nothing */}
        {betValue && selectedBetData ? (
          <PlaceBet
            betValue={betValue}
            playerName={selectedPlayerName}
            playerNameForApi={selectedPlayerNameForApi}
            setShowPlaceBet={setShowPlaceBet}
            gameId={d?.mid?.toString() || "98765"}
            gameName="teen6"
            roundId={d?.mid || 0}
            selection={selectedSelection}
            betData={selectedBetData}
            betType={selectedBetType}
            onBetPlaced={handleBetPlaced}
          />
        ) : null}
      </>
      <ViewMoreModal
        show={showViewMoreModal}
        onHide={() => setShowViewMoreModal(false)}
        title="View More"
        sectionKey="teen6"
        formatNation={formatTeen6Nation}
      />
    </CasinoTableLayout>
  );
}
